import React from 'react'
import { GridCellParams, GridFilterInputValueProps, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { t as trans } from 'i18next'
import { FilterOperator, FilterTypes, usePaymentMethodsQuery } from '@typings/graphql'

import { PaginatedBookingColumnType } from '../PaymentHistoryDataGrid'

const RenderedFilter:React.FC<GridFilterInputValueProps> = (props) => {
  const { item, applyValue } = props
  const { t } = useTranslation()

  const { data } = usePaymentMethodsQuery()

  const handleFilterChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value?.length ? event.target.value : null })
  }

  return (
    <FormControl variant='standard'>
      <InputLabel htmlFor="my-input">{t('payment.paymentMethod')}</InputLabel>
      <Select multiple onChange={handleFilterChange} value={item.value ?? []}>
        {data?.paymentMethods.map((method) => (
          <MenuItem key={method} value={method}>
            {t(`payment.paymentMethodType.${method}`)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

const getApplyFilterFn = (filterItem: GridFilterItem) => {
  if (!filterItem.field || !filterItem.value || !filterItem.value.length || !filterItem.operator) {
    return null
  }

  return (params: GridCellParams) => {
    return params.value === filterItem.value
  }
}

const paymentMethodFilterModel: GridFilterOperator[] = [{
  label: trans('filterOperator.equals'),
  value: FilterOperator.Like as string,
  getApplyFilterFn,
  InputComponent: RenderedFilter
}, {
  label: trans('filterOperator.not'),
  value: FilterOperator.NotLike as string,
  getApplyFilterFn,
  InputComponent: RenderedFilter
}]

export const paymentMethodColumnModel: PaginatedBookingColumnType = {
  field: 'paymentMethod',
  width: 200,
  filterType: FilterTypes.Select,
  valueGetter: (params) => params.row.payment?.paymentMethod?.toLowerCase() || 'coupon',
  renderCell: (params) => trans(`payment.paymentMethodType.${params.row.payment?.paymentMethod?.toLowerCase() || 'coupon'}`) as string,
  filterOperators: paymentMethodFilterModel
}
